import type { ImgHTMLAttributes } from "react";
import { leadCatBrand } from "../../brand/brandConfig";
import styles from "./LeadCatHeroArtwork.module.css";

interface LeadCatHeroArtworkProps extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "srcSet" | "width" | "height"> {
  priority?: boolean;
}

export function LeadCatHeroArtwork({
  priority = false,
  alt = `LeadCat — ${leadCatBrand.tagline}`,
  className = "",
  sizes = "(max-width: 720px) 100vw, (max-width: 1200px) 60vw, 724px",
  ...props
}: LeadCatHeroArtworkProps) {
  return (
    <img
      {...props}
      className={`${styles.heroArtwork} ${className}`}
      src={leadCatBrand.assets.hero}
      srcSet={leadCatBrand.assets.heroSrcSet}
      sizes={sizes}
      width={1448}
      height={1086}
      alt={alt}
      loading={priority ? "eager" : "lazy"}
      fetchPriority={priority ? "high" : "auto"}
      decoding="async"
      data-brand-asset="marketing-hero"
    />
  );
}
